<div class="date-picker-availability-dates">
  <form [formGroup]="formGroup" class="column">
    <div>
      <div style="font-size: 14px">First available date (minimal time to deliver)</div>
      <div class="flex-row">
        <pdq-input-arrows variant="form" formControlName="firstAvailableDate" min="0"></pdq-input-arrows>
        <pdq-dropdown
          placeholder="Business days"
          formControlName="firstAvailableDateType"
          [options]="availabilityDatesTypeOptions"
          [defaultOption]="availabilityDatesTypeOptions[0]"></pdq-dropdown>

        <pdq-checkbox
          formControlName="skipFirstAvailableDateSelection"
          label="Skip as default selection"
          icon="more_information"
          description="Skips day from being calendar’s earliest default selection day"></pdq-checkbox>
      </div>
    </div>
    <div>
      <div style="font-size: 14px">Last available date (maximal time to deliver)</div>
      <div class="flex-row">
        <pdq-input-arrows variant="form" formControlName="lastAvailableDate" min="0"></pdq-input-arrows>
        <pdq-dropdown
          placeholder="Business days"
          formControlName="lastAvailableDateType"
          [options]="availabilityDatesTypeOptions"
          [defaultOption]="availabilityDatesTypeOptions[0]"></pdq-dropdown>
      </div>
    </div>
  </form>
</div>
